import { Type } from "../type";

export const productCreateMutations = {
  [Type.PRODUCT_CREATE_SUCCESS](state, payload) {
    state.productList = [payload.data, ...state.productList];
    console.log(payload.data);
  },
  [Type.PRODUCT_CREATE_FAILURE](state, payload) {
    console.log(payload);
  },
};
